import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import * as Sentry from "@sentry/react";
import "@/index.css";
import App from "@/App";

// Initialize Sentry for error monitoring
Sentry.init({
  dsn: "https://58905e25b234946f85b6cb27875c6bea@o4511444859944960.ingest.de.sentry.io/4511444866891856",
  environment: process.env.NODE_ENV || 'development',
  // Send default PII data (IP address collection)
  sendDefaultPii: true,
  // Sample rate for performance monitoring
  tracesSampleRate: 0.2,
  // Only enable in production
  enabled: process.env.NODE_ENV === 'production' || window.location.hostname.includes('preview.emergentagent.com'),
});

// Force HTTPS in production to prevent mixed content issues
if (typeof window !== 'undefined' && window.location.protocol === 'https:') {
  axios.interceptors.request.use(config => {
    if (config.url && config.url.startsWith('http://')) {
      config.url = config.url.replace('http://', 'https://');
    }
    return config;
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p>An error has occurred. Please refresh the page.</p>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
